{
  "nav": { "items": { "myPage": "صفحتي" } },
  "myPage": {
    "subtitle": "صفحتك العامة على {{brand|بارسينا}}: اختر قالبًا ورتّب الأقسام ثم انشرها.",
    "loading": "جارٍ تجهيز صفحتك",
    "loadFailed": "تعذّر تحميل صفحتك",
    "railLabel": "إعدادات الصفحة",
    "markdownHint": "التنسيق البسيط مدعوم: # عنوان، **عريض**، قوائم بـ - وروابط بالشكل [نص](https://…). لا يُقبل HTML.",
    "markdownHintShort": "**العريض** والقوائم بـ - والروابط مدعومة.",
    "tabs": { "label": "أقسام صفحتي", "builder": "تحرير الصفحة", "leads": "طلبات الصفحة" },
    "status": {
      "draft": "مسودة",
      "published": "منشورة",
      "unpublished": "أُلغي نشرها",
      "suspended": "معلّقة",
      "unknown": "غير معروف"
    },
    "statusCard": {
      "title": "حالة الصفحة",
      "liveUrl": "عنوان صفحتك",
      "futureUrl": "بعد النشر ستكون الصفحة متاحة على هذا العنوان",
      "copy": "نسخ العنوان",
      "copied": "تم نسخ العنوان",
      "copyFailed": "تعذّر نسخ العنوان",
      "lastPublished": "آخر نشر: {{date}}",
      "preview": "معاينة",
      "openPreview": "فتح المعاينة",
      "popupBlocked": "حظر المتصفح نافذة المعاينة؛ استخدم الرابط أدناه.",
      "publish": "نشر",
      "republish": "نشر التغييرات",
      "unpublish": "إلغاء النشر",
      "unpublishTitle": "إلغاء نشر الصفحة؟",
      "unpublishBody": "ستُزال الصفحة من الإنترنت ولن يعمل عنوانها. يُحفظ كل المحتوى ويمكنك النشر مجددًا.",
      "unpublishConfirm": "ألغِ النشر",
      "unpublished": "أُلغي نشر الصفحة",
      "unpublishFailed": "تعذّر إلغاء النشر. حاول مجددًا.",
      "blockersTitle": "للنشر، أكمل ما يلي:",
      "addCouncil": "أضف رقم النقابة الطبية في ملفك الشخصي"
    },
    "banner": {
      "suspendedTitle": "علّقت {{brand|بارسينا}} صفحتك",
      "suspendedNoReason": "لم يُسجَّل سبب.",
      "suspendedSupport": "الصفحة للقراءة فقط. تواصل مع دعم {{brand|بارسينا}} لرفع التعليق.",
      "unpublishedChanges": "لديك تغييرات لم تُنشر بعد؛ يرى الزوار النسخة السابقة."
    },
    "save": {
      "save": "حفظ",
      "reset": "إعادة تعيين",
      "saving": "جارٍ الحفظ…",
      "saved": "تم الحفظ",
      "dirty": "تغييرات غير محفوظة"
    },
    "publish": {
      "title": "نشر الصفحة",
      "intro": "بعد النشر يمكن للجميع على الإنترنت رؤية صفحتك والبحث عنها. قبل النشر أكّد ما يلي:",
      "rule1": "المحتوى متوافق مع ضوابط الإعلان للنقابة الطبية ولا يدّعي شفاءً مؤكدًا أو نتيجة مضمونة أو مقارنة بالزملاء.",
      "rule2": "الصور والنصوص ملكك أو لديك إذن باستخدامها.",
      "rule3": "تُنشر آراء المرضى بموافقتهم، ولا تحتوي الصفحة على معلومات طبية شخصية.",
      "rule4": "أنت مسؤول عن محتوى الصفحة، ويمكن ل{{brand|بارسينا}} تعليق الصفحة المخالفة لهذه الضوابط.",
      "public": "الصفحة عامة: يراها كل من لديه عنوانها ومحركات البحث.",
      "accept": "قرأت هذه البنود وأوافق عليها",
      "confirm": "انشر",
      "cancel": "إلغاء",
      "failedTitle": "لم يتم النشر؛ صحّح ما يلي",
      "done": "تم نشر صفحتك"
    },
    "template": { "title": "القالب" },
    "templates": {
      "classic": { "name": "كلاسيكي", "description": "مطبوع ورصين: صورة مؤطّرة وعنوان كبير بتظليل ملوّن وصورة الخلفية كشريط أعلى الصفحة وشريط لأبرز النقاط." },
      "modern": { "name": "عصري", "description": "كصفحة رئيسية لعيادة: عنوان كبير وصورة خلفية وبطاقات بجانب الصورة وشريط لأبرز النقاط." },
      "minimal": { "name": "بسيط", "description": "طباعي وهادئ بلا غلاف؛ يركّز على النص والخدمات والمقالات." }
    },
    "palettes": {
      "azure": "لازوردي",
      "teal": "فيروزي",
      "deep": "كحلي",
      "brand": "هوية {{brand|بارسينا}}",
      "cyan": "سماوي",
      "ink": "حبري"
    },
    "theme": {
      "title": "اللون والكثافة",
      "palette": "لوحة الألوان",
      "density": "الكثافة",
      "densities": { "comfortable": "مريحة", "compact": "مضغوطة" },
      "onlyTemplate": "تُعرض فقط الألوان والكثافات التي يدعمها القالب الحالي."
    },
    "slug": {
      "label": "عنوان الصفحة",
      "hint": "أحرف إنجليزية صغيرة وأرقام وشرطة؛ من ٣ إلى ٤٠ محرفًا. الافتراضي رقم نقابتك الطبية.",
      "lockedHint": "ثُبّت العنوان عند أول نشر ولا يمكن تغييره بعد الآن.",
      "required": "أدخل عنوانًا.",
      "invalid": "أحرف إنجليزية صغيرة وأرقام وشرطة فقط، من ٣ إلى ٤٠ محرفًا؛ يبدأ وينتهي بحرف أو رقم، دون شرطتين متتاليتين.",
      "checking": "جارٍ التحقق…",
      "available": "هذا العنوان متاح.",
      "taken": "هذا العنوان غير متاح.",
      "save": "حفظ العنوان"
    },
    "sections": {
      "title": "الأقسام",
      "reorderHint": "غيّر الترتيب بزرّي الأعلى والأسفل (أو Alt ومفاتيح الأسهم).",
      "kinds": {
        "hero": "الملف المهني",
        "services": "الخدمات",
        "articles": "المقالات",
        "testimonials": "آراء مختارة للمرضى",
        "gallery": "معرض الصور",
        "video": "فيديو",
        "office": "معلومات العيادة",
        "booking": "حجز المواعيد"
      },
      "show": "إظهار «{{name}}» في الصفحة",
      "shown": "معروض",
      "hidden": "مخفي",
      "hiddenNotice": "هذا القسم مخفي ولا يظهر في صفحتك العامة.",
      "showOnPage": "إظهار في الصفحة",
      "toggleFailed": "تعذّر تغيير ظهور «{{name}}»:",
      "required": "يُعرض هذا القسم دائمًا",
      "moveUp": "نقل «{{name}}» إلى الأعلى",
      "moveDown": "نقل «{{name}}» إلى الأسفل",
      "unsupported": "لا يُعرض في هذا القالب",
      "unsupportedLong": "لا يعرض القالب الحالي هذا القسم. يُحفظ محتواه ويظهر مجددًا عند تغيير القالب.",
      "hasErrors": "هذا القسم يمنع النشر",
      "titleOverride": "عنوان القسم (اختياري)",
      "titleOverrideHint": "اتركه فارغًا لعرض العنوان الافتراضي.",
      "reorderFailed": "لم يُحفظ ترتيب الأقسام. حاول مجددًا.",
      "booking": {
        "intro": "يمكن لزائر الصفحة اختيار وقت متاح في إحدى عياداتك أو طلب الاتصال به فقط. العيادة هي التي تحدد ما إذا كانت الخدمة عامة وقابلة للحجز المباشر.",
        "enabled": "عرض حجز المواعيد في الصفحة",
        "enabledHint": "عند الإيقاف يبقى نموذج «طلب الاتصال» فقط في الصفحة.",
        "clinic": "العيادة",
        "clinicPlaceholder": "اختيار العيادة",
        "clinicSingleHint": "العيادة الوحيدة التي أنت عضو فيها.",
        "noClinicsTitle": "لحجز المواعيد يجب أن تكون عضوًا في عيادة",
        "noClinicsBody": "تُدار العضوية من قسم «العيادات» في الإعدادات.",
        "goClinics": "العيادات",
        "mode": "طريقة الحجز",
        "modes": { "slots": "اختيار وقت من الأوقات المتاحة", "request": "طلب الاتصال فقط" },
        "modeHints": {
          "slots": "يرى الزائر الأوقات المتاحة ويحجز بعد تسجيل الدخول إلى تطبيق المريض.",
          "request": "يُعرض نموذج «طلب الاتصال» فقط."
        },
        "services": "الخدمات",
        "servicesHint": "تُعرض فقط الخدمات التي جعلتها العيادة عامة. الخدمة «بإحالة الطبيب» تُعرض بهذه الشارة ولا يمكن للزائر حجزها مباشرة.",
        "servicesEmpty": "لا توجد لهذه العيادة خدمة عامة لك بعد.",
        "kinds": { "direct": "حجز مباشر", "referral": "بإحالة الطبيب" },
        "duration": "{{minutes}} دقيقة",
        "unavailable": "لم تعد عامة",
        "unavailableHint": "الخدمة التي لم تعد عامة تُحذف عند الحفظ.",
        "horizon": "أفق العرض",
        "horizonDays": "{{days}} يومًا",
        "horizonHint": "تُعرض الأوقات المتاحة حتى هذا العدد من الأيام القادمة.",
        "previewNote": "تُعرض الأوقات المتاحة في الصفحة المنشورة.",
        "loadFailed": "تعذر تحميل خيارات الحجز",
        "errors": {
          "BOOKING_CLINIC_REQUIRED": "اختر العيادة.",
          "BOOKING_CLINIC_NOT_MEMBER": "لم تعد عضوًا في هذه العيادة؛ اختر عيادة أخرى.",
          "BOOKING_SERVICES_REQUIRED": "اختر خدمة واحدة على الأقل.",
          "BOOKING_SERVICE_UNAVAILABLE": "بعض الخدمات المختارة لم تعد عامة وستُحذف عند الحفظ."
        }
      }
    },
    "items": {
      "count": "{{count}} من {{max}}",
      "moveUp": "نقل للأعلى",
      "moveDown": "نقل للأسفل",
      "remove": "حذف"
    },
    "image": {
      "pick": "اختيار صورة",
      "replace": "تغيير الصورة",
      "remove": "حذف الصورة",
      "removeTitle": "حذف الصورة؟",
      "removeBody": "تُحذف الصورة من الصفحة، وبعد النشر التالي تُزال من الصفحة العامة أيضًا.",
      "removeConfirm": "احذف",
      "cropTitle": "قص الصورة",
      "typeUnsupported": "تُقبل صور JPEG أو PNG فقط.",
      "tooLarge": "حجم الصورة أكبر من ٥ ميغابايت.",
      "readFailed": "تعذّرت قراءة الملف."
    },
    "hero": {
      "displayName": "الاسم المعروض",
      "displayNameRequired": "الاسم المعروض مطلوب.",
      "headline": "عنوان قصير",
      "headlinePlaceholder": "مثلًا: أخصائي قلب، عضو هيئة تدريس",
      "headlineHint": "في قالبَي «العصري» و«الكلاسيكي» يظهر بخط كبير أعلى الصفحة؛ وإذا احتوى على فاصلة فيظهر ما بعدها ملوّنًا.",
      "about": "نبذة عني",
      "portrait": "الصورة الشخصية",
      "portraitHint": "نسخة منفصلة من صورة ملفك الشخصي؛ تغييرها لا يؤثر في ملفك.",
      "cover": "صورة الخلفية",
      "coverHint": "صورة عريضة (بنسبة ٣ إلى ١ تقريبًا). في قالب «العصري» تظهر باهتة خلف أعلى الصفحة، وفي «الكلاسيكي» كشريط أعلى الصفحة.",
      "coverUnused": "القالب الحالي لا يعرض صورة الخلفية؛ اختر قالب «العصري» أو «الكلاسيكي» لرؤيتها.",
      "extras": {
        "onlyModern": "تظهر هاتان القائمتان في قالبَي «العصري» و«الكلاسيكي». وإذا بقيتا فارغتين فستحلّ محلّهما خدماتك الأولى ورقم النظام والمدينة وساعات العمل.",
        "notShown": "القالب الحالي لا يعرض هاتين القائمتين؛ اختر قالب «العصري» أو «الكلاسيكي» لرؤيتهما.",
        "cardsTitle": "بطاقات التعريف",
        "cardsHint": "بطاقتان قصيرتان على الأكثر في أعلى الصفحة؛ مثلًا «زيارة حضورية وعن بُعد».",
        "addCard": "إضافة بطاقة",
        "highlightsTitle": "أبرز النقاط",
        "highlightsHint": "ثلاثة عناصر على الأكثر في الشريط أسفل أعلى الصفحة؛ مثلًا «١٥ سنة خبرة».",
        "addHighlight": "إضافة نقطة",
        "itemTitle": "العنوان",
        "itemText": "نص قصير (اختياري)",
        "titleRequired": "العنوان مطلوب."
      }
    },
    "services": {
      "itemTitle": "اسم الخدمة",
      "itemDescription": "الوصف",
      "image": "صورة الخدمة",
      "imageHint": "نسبة ٤ إلى ٣؛ يُستخدم اسم الخدمة نصًا بديلًا للصورة.",
      "imageAfterSave": "يمكنك إضافة صورة بعد حفظ هذه الخدمة.",
      "add": "إضافة خدمة"
    },
    "testimonials": {
      "framingTitle": "آراء مختارة، لا تقييمات",
      "framing": "يضم هذا القسم اقتباسات تختارها وتُدخلها بنفسك، وتُعرض تحت عنوان «آراء مختارة للمرضى». لا تُعرض في الصفحة تقييمات أو نجوم أو عدد آراء.",
      "text": "نص الرأي",
      "attribution": "الاسم المعروض للمريض",
      "attributionPlaceholder": "مثلًا «م. رضائي» أو «مريض عمره ٤٥ عامًا»",
      "consent": "وافق المريض على نشر هذا الرأي في الصفحة العامة",
      "consentRequired": "لا يُحفظ هذا الرأي دون تأكيد موافقة المريض.",
      "add": "إضافة رأي"
    },
    "video": {
      "intro": "الصق عنوان الفيديو من آبارات أو يوتيوب؛ يُحفظ معرّف الفيديو فقط.",
      "url": "عنوان الفيديو",
      "caption": "وصف قصير",
      "add": "إضافة فيديو",
      "pending": "يُفحص عند الحفظ",
      "aparat": "آبارات",
      "youtube": "يوتيوب"
    },
    "gallery": {
      "alt": "النص البديل",
      "altRequired": "النص البديل مطلوب.",
      "saveAlt": "حفظ النص",
      "newAlt": "وصف الصورة الجديدة",
      "newAltPlaceholder": "مثلًا «غرفة انتظار العيادة»",
      "altFirst": "اكتب وصف الصورة أولًا.",
      "emptyTitle": "لا توجد صور في المعرض بعد",
      "emptyHint": "أضف حتى ١٢ صورة للعيادة والأجهزة."
    },
    "articles": {
      "new": "مقالة جديدة",
      "back": "العودة إلى المقالات",
      "title": "عنوان المقالة",
      "slug": "عنوان المقالة في الرابط (اختياري)",
      "slugHint": "اتركه فارغًا ليُبنى من العنوان. يُثبّت عند أول نشر.",
      "slugLocked": "عنوان المقالة:",
      "body": "نص المقالة",
      "cover": "صورة المقالة",
      "publish": "نشر المقالة",
      "unpublish": "إعادة إلى مسودة",
      "republish": "نشر تغييرات المقالة",
      "delete": "حذف المقالة",
      "deleteTitle": "حذف المقالة؟",
      "deleteBody": "ستُحذف المقالة «{{title}}» نهائيًا.",
      "deleteConfirm": "احذف",
      "saveFirst": "احفظ التغييرات قبل النشر.",
      "saveToContinue": "بعد الحفظ يمكنك إضافة صورة ونشر المقالة.",
      "untitled": "بلا عنوان",
      "publishedOn": "نُشرت في {{date}}",
      "neverPublished": "لم تُنشر بعد",
      "statusPublished": "منشورة",
      "statusDraft": "مسودة",
      "changed": "تغييرات غير منشورة",
      "emptyTitle": "لم تكتب أي مقالة بعد",
      "emptyHint": "المقالات التثقيفية للمرضى تجعل صفحتك أسهل ظهورًا في البحث."
    },
    "office": {
      "intro": "ما تُدخله هنا يُعرض في الصفحة العامة كما هو.",
      "phones": "الهواتف",
      "phoneLabel": "التسمية",
      "phoneLabelPlaceholder": "مثلًا: السكرتارية",
      "phoneNumber": "الرقم",
      "addPhone": "إضافة هاتف",
      "city": "المدينة",
      "address": "عنوان العيادة",
      "hours": "ساعات العمل",
      "hoursLabel": "الأيام",
      "hoursLabelPlaceholder": "مثلًا: السبت إلى الأربعاء",
      "hoursValue": "الساعات",
      "hoursValuePlaceholder": "مثلًا: ١٦ إلى ٢٠",
      "addHours": "إضافة ساعات عمل",
      "geo": "الموقع على الخريطة (اختياري)",
      "geoHint": "حدّد العيادة على الخريطة ليتمكن المرضى من صفحتك من الوصول إليها عبر نشان أو بلد أو خرائط Google.",
      "map": {
        "pick": "الاختيار على الخريطة",
        "change": "التغيير على الخريطة",
        "close": "إغلاق الخريطة",
        "myLocation": "موقعي الحالي",
        "clear": "حذف الموقع",
        "isSet": "تم تحديد موقع العيادة على الخريطة.",
        "label": "خريطة اختيار موقع العيادة",
        "hint": "انقر على الخريطة أو اسحب الدبوس ليكون على العيادة تمامًا، ثم اضغط «حفظ».",
        "found": "وُضع الدبوس على موقعك الحالي. إن لم تكن في العيادة الآن فانقله إليها.",
        "locating": "جارٍ تحديد موقعك…",
        "loading": "جارٍ تحميل الخريطة…",
        "failed": "تعذّر تحميل الخريطة. إن كنت في العيادة فاضغط «موقعي الحالي».",
        "denied": "لم يُسمح بالوصول إلى الموقع؛ انقر على الخريطة لتحديد العيادة.",
        "unavailable": "تعذّر العثور على موقعك؛ انقر على الخريطة لتحديد العيادة.",
        "timeout": "استغرق تحديد موقعك وقتًا طويلًا؛ أعد المحاولة أو انقر على الخريطة.",
        "unsupported": "هذا المتصفح لا يدعم تحديد الموقع؛ انقر على الخريطة لتحديد العيادة."
      },
      "socials": "الشبكات الاجتماعية",
      "socialsHint": "أدخل المعرّف أو عنوان الصفحة (مثلًا @dr.example أو instagram.com/dr.example). واتساب: الرقم الكامل مع رمز الدولة. الموقع: العنوان الكامل.",
      "social": {
        "instagram": "إنستغرام",
        "telegram": "تيليغرام",
        "whatsapp": "واتساب",
        "eitaa": "إيتا",
        "bale": "بله",
        "website": "الموقع الإلكتروني"
      }
    },
    "leads": {
      "intro": "طلبات أرسلها الزوار من صفحتك. يتابعها فريق {{brand|بارسينا}}.",
      "name": "الاسم",
      "mobile": "الجوال",
      "preference": "طريقة ووقت التواصل",
      "message": "الرسالة",
      "createdAt": "وقت الاستلام",
      "status": "الحالة",
      "more": "عرض المزيد",
      "loadFailed": "تعذّر تحميل الطلبات",
      "emptyTitle": "لا توجد طلبات بعد",
      "emptyHint": "شارك عنوان صفحتك مع المرضى ليتواصلوا معك عبر «طلب موعد».",
      "notPublishedTitle": "لم تُنشر الصفحة بعد",
      "notPublishedHint": "بعد النشر تظهر طلبات الزوار هنا.",
      "channels": { "call": "مكالمة هاتفية", "sms": "رسالة نصية", "whatsapp": "واتساب" },
      "times": { "morning": "صباحًا", "afternoon": "بعد الظهر", "evening": "مساءً", "any": "أي وقت" },
      "statuses": {
        "new": "جديد",
        "contacted": "تم التواصل",
        "qualified": "قيد المتابعة",
        "proposal": "قيد المتابعة",
        "negotiation": "قيد المتابعة",
        "won": "تم",
        "lost": "مغلق"
      }
    }
  }
}
